import { types } from "./Constants";
import { Auth } from "aws-amplify";

export default {
  [types.AuthToken]: "",
  [types.ScreenSize]: [0, 0],
};
